/**
 * src/components/GameLoader.jsx
 * หน้าโหลดก่อนเข้าเกม
 */
import { memo, useEffect, useState } from 'react';

function GameLoaderInner({ progress = 0, label = 'กำลังโหลด...', ready = false }) {
  const [gone, setGone] = useState(false);
  const pct = Math.max(0, Math.min(100, Math.round(progress)));

  useEffect(() => {
    document.getElementById('boot-loader')?.remove();
  }, []);

  useEffect(() => {
    if (!ready) return undefined;
    const t = window.setTimeout(() => setGone(true), 480);
    return () => window.clearTimeout(t);
  }, [ready]);

  if (gone) return null;

  return (
    <div
      className={`game-loader${ready ? ' is-done' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy={!ready}
    >
      <div className="game-loader-inner">
        <p className="game-loader-kicker">ระบายอารมณ์</p>
        <h1 className="game-loader-title">ยิงกำแพง</h1>
        <p className="game-loader-label">{ready ? 'พร้อมแล้ว' : label}</p>
        <div
          className="game-loader-track"
          aria-label={`โหลด ${pct}%`}
        >
          <div
            className="game-loader-fill"
            style={{ width: `${ready ? 100 : pct}%` }}
          />
        </div>
        <p className="game-loader-pct">{ready ? 100 : pct}%</p>
      </div>
    </div>
  );
}

const GameLoader = memo(GameLoaderInner);
export default GameLoader;
